<template>
  <div class="form-date">
    <datepicker
      v-model="date"
      placeholder="選択してください"
      :id="name"
      :name="name"
      :format="format"
      :disabled="disabled"
      :input-class="['datepicker',{'is-error':error}]"
      @input="updateValue"
    ></datepicker>
    <label
      :for="name"
      class="label"
      :class="{'is-disabled':disabled}"
    ><img src="@/assets/images/icon_calendar.png" alt=""></label>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'form-date',
  components: {
    Datepicker
  },
  props: {
    value: { type: [Date, String], require: true },
    name: { type: String, require: true },
    disabled: { type: Boolean, require: false, 'default':false },
    error: { type: Boolean, require: false, 'default':false }
  },
  data() {
    return {
      date: '',
      format: 'yyyy年M月d日'
    };
  },
  mounted() {
    this.date = this.value
  },
  methods: {
    updateValue: function() {
      this.$emit("input", this.date)
    }
  }
}

</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";
.form-date {
  display: flex;
  align-items: center;
  @include mq-down(sm) {
    width: 100%;
    > .vdp-datepicker {
      width: 100%;
    }
  }
  > .label {
    &:not(.is-disabled) {
      cursor: pointer;
    }
    > img {
      width: 36px;
      margin-left: 10px;
    }
  }
}
</style>
<style lang="scss">
@import "../../assets/stylesheets/styles";
.datepicker {
  display: block;
  position: relative;
  padding: 0 10px;
  width: 100%;
  height: 40px;
  background-color: #fff;
  border-radius: 5px;
  border: 1px solid $border;
  font-size: 14px;
  &::placeholder {
    color: inherit;
  }
  @include mq-up(sm) {
    width: 200px;
  }
  &:disabled {
		background-color: #eee;
		color: #777;
  }
  &.is-error {
    background-color: $error-bg;
  }
}
</style>
  